// export const AccrRequestFixedColumns: Partial<ITableColumnConfig>[] = [

import { ITableColumnConfig } from '../../components/DataTable/IDataTable';

export const MY_FORMS_COLUMNS: ITableColumnConfig[] = [
  {
    dataField: 'formDefId',
    headerLabel: 'NAME',
    type: "text",
    cellSize: 3,
  },
  {
    dataField: 'status',
    headerLabel: 'STATUS',
    type: 'custom',
    component: 'renderStatus',
    cellSize: 3,
  },
  {
    dataField: 'registerLabel',
    headerLabel: 'ACTIONS',
    type: "link",
    linkUrl: "formPath",
    cellSize: 3,
  },



];
